import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7be723a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "tw-border-solid tw-border tw-border-[#EFF0F1] tw-rounded-md tw-h-[185px] tw-bg-[#FCFCFC] tw-max-w-[900px]"
}
const _hoisted_3 = { class: "tw-px-[20px] tw-pt-[20px] tw-flex tw-items-center tw-justify-between tw-h-[36px]" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-h-[16px] tw-text-base tw-font-semibold tw-w-full tw-text-[#211F58]" }
const _hoisted_5 = ["value"]

import { getComponentUiText } from "@/utils/utilities";
import { ApexOptions } from "apexcharts";
import { computed, onMounted, Ref, ref, watch } from "vue";
import store from "@/store";
import { TYPE_ISSUE_OVER_TIME_OPTIONS } from "@/utils/constants";
import cloneDeep from "lodash/cloneDeep";
import { connectNulls, getMarkers } from "@/utils/apexChart";
import LineChart, { IChartSeries } from "../chart/lineChart.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'issuesOverTime',
  props: {
  loading: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



const filterSelected = ref(TYPE_ISSUE_OVER_TIME_OPTIONS.Total);
const option: Ref<ApexOptions> = ref({});
const series: Ref<IChartSeries[]> = ref([]);

const monthOfYear = [
  getComponentUiText("app-scanning-schedule-modal-option-january-1"),
  getComponentUiText("app-scanning-schedule-modal-option-february-1"),
  getComponentUiText("app-scanning-schedule-modal-option-march-1"),
  getComponentUiText("app-scanning-schedule-modal-option-april-1"),
  getComponentUiText("app-scanning-schedule-modal-option-may-1"),
  getComponentUiText("app-scanning-schedule-modal-option-june-1"),
  getComponentUiText("app-scanning-schedule-modal-option-july-1"),
  getComponentUiText("app-scanning-schedule-modal-option-august-1"),
  getComponentUiText("app-scanning-schedule-modal-option-september-1"),
  getComponentUiText("app-scanning-schedule-modal-option-october-1"),
  getComponentUiText("app-scanning-schedule-modal-option-november-1"),
  getComponentUiText("app-scanning-schedule-modal-option-december-1"),
];

const dropdownData = [
  {
    name: getComponentUiText(
      "app-component-assessments-assessment-question-total-score-1",
    ),
    value: TYPE_ISSUE_OVER_TIME_OPTIONS.Total,
  },
  {
    name: getComponentUiText("app-scan-scanning-domains-1"),
    value: TYPE_ISSUE_OVER_TIME_OPTIONS.Domains,
  },
  {
    name: getComponentUiText("app-scan-scanning-web-services-1"),
    value: TYPE_ISSUE_OVER_TIME_OPTIONS.WebServices,
  },
];

const scanIssuesOverTimeCount = computed(() =>
  store.getters["Scanning/GET_ISSUES_OVER_TIME_COUNTS"](filterSelected.value),
);

onMounted(() => {
  onProceedData();
});

const onProceedData = () => {
  if (
    !scanIssuesOverTimeCount.value.total ||
    scanIssuesOverTimeCount.value.total.length === 0
  ) {
    return;
  }
  const dataArray = cloneDeep(scanIssuesOverTimeCount.value.total);
  series.value = connectNulls(cloneDeep(scanIssuesOverTimeCount.value.total));
  // get max and min checklistScorePcnt
  const maxScore = Math.max(...dataArray);
  const minScore = Math.min(...dataArray);
  const fiftyPercentile = (maxScore + minScore) * 0.5;
  const markers = getMarkers(
    cloneDeep(dataArray),
    cloneDeep(series.value)[0].data,
    true,
  );
  option.value = {
    stroke: { width: 3, curve: "straight" },
    chart: { toolbar: { show: false } },
    tooltip: {
      custom: ({ series, seriesIndex, dataPointIndex, w }) =>
        tooltipCustom({ series, seriesIndex, dataPointIndex, w }),
    },
    series: connectNulls(cloneDeep(scanIssuesOverTimeCount.value.total)),
    xaxis: {
      type: "category",
      categories: scanIssuesOverTimeCount.value.month,
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: true,
        color: "#EFF0F1",
        strokeWidth: 2,
      },
      tickAmount: 10,
      labels: {
        style: {
          fontSize: "10px",
          fontWeight: 500,
          colors: "#878787",
        },
        formatter: (value) => {
          return monthOfYear[value - 1]?.charAt(0);
        },
      },
    },
    yaxis: {
      tickAmount: 4,
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: true,
        color: "#EFF0F1",
        width: 2,
        offsetX: -4,
      },
      labels: {
        style: {
          fontSize: "8px",
          fontWeight: 500,
          colors: "#878787",
        },
        formatter: (value) => {
          return Number(value).toFixed(0);
        },
      },
    },
    markers: {
      size: 7,
      strokeWidth: 2.5,
      discrete: markers,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        type: "vertical",
        inverseColors: true,
        colorStops: [
          {
            offset: 0,
            color: "#F70000",
            opacity: 1,
          },
          {
            offset: fiftyPercentile,
            color: "#FFA300",
            opacity: 1,
          },
          {
            offset: 100,
            color: "#01893D",
            opacity: 1,
          },
        ],
      },
    },
    grid: {
      borderColor: "#EFF0F1",
      strokeDashArray: 3,
      padding: { left: 10, right: 20, top: 0, bottom: 10 },
    },
  };
};

const onFiltered = (e) => {
  filterSelected.value = e.target.value;
};

watch(scanIssuesOverTimeCount, () => {
  onProceedData();
});

const getColor = (value: number) => {
  if (value < 30) {
    return "green";
  }
  if (value < 35) {
    return "yellow";
  }
  return "red";
};
const tooltipCustom = ({ series, seriesIndex, dataPointIndex, w }) => {
  return `<div
      class="apexcharts-tooltip-title"
      style="font-family: Helvetica, Arial, sans-serif; font-size: 12px"
    >
      ${monthOfYear[scanIssuesOverTimeCount.value.month[dataPointIndex] - 1]}
    </div>
    <div
      class="apexcharts-tooltip-series-group apexcharts-active"
      style="order: 1; display: flex"
    >
      <span
        class="apexcharts-tooltip-marker"
        style="background-color: ${getColor(
          series[seriesIndex][dataPointIndex],
        )}"
      ></span>
      <div
        class="apexcharts-tooltip-text"
        style="font-family: Helvetica, Arial, sans-serif; font-size: 12px"
      >
        <div class="apexcharts-tooltip-y-group">
          <span class="apexcharts-tooltip-text-y-label" >${
            scanIssuesOverTimeCount.value.total[dataPointIndex] !== null
              ? getComponentUiText("app-scan-scanning-issues-number-block-1") +
                ": "
              : ""
          }</span
          ><span class="apexcharts-tooltip-text-y-value">${
            scanIssuesOverTimeCount.value.total[dataPointIndex] === null
              ? getComponentUiText(
                  "app-scanning-page-issue-over-time-label-no-data-1",
                )
              : series[seriesIndex][dataPointIndex]
          }</span>
        </div>
        <div class="apexcharts-tooltip-goals-group">
          <span class="apexcharts-tooltip-text-goals-label"></span
          ><span class="apexcharts-tooltip-text-goals-value"></span>
        </div>
        <div class="apexcharts-tooltip-z-group">
          <span class="apexcharts-tooltip-text-z-label"></span
          ><span class="apexcharts-tooltip-text-z-value"></span>
        </div>
      </div>
    </div>`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (!scanIssuesOverTimeCount.value.value?.total && !__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("app-scanning-page-issue-over-time-title-1")), 1),
            _createElementVNode("select", {
              class: "right-title",
              onInput: _cache[0] || (_cache[0] = (e) => onFiltered(e))
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dropdownData, (data, index) => {
                return _createElementVNode("option", {
                  key: index,
                  value: data.value,
                  class: "tw-text-[#211F58] tw-text-center tw-text-[11px] tw-font-medium tw-leading-[8px]"
                }, _toDisplayString(data.name), 9, _hoisted_5)
              }), 64))
            ], 32)
          ]),
          _createVNode(LineChart, {
            height: 149,
            series: series.value,
            "chart-options": option.value
          }, null, 8, ["series", "chart-options"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})